import { observable } from "mobx";
import { wordPressService } from "../../../../cdm/services/wordpress-service";
import { endpointConfig } from "../../../../config/api-config";

export class AdminJobPostingPageController {
  @observable loading = false;
  frameUrl = "";

  constructor(props) {
    this.props = props;
    this._initialize();
  }

  _initialize = () => {
    // wordPressService.setLoading(true);
    wordPressService.setWpHostname(endpointConfig.job_posting_hostname);
    this.frameUrl = `${window.location.protocol}//${
      endpointConfig.job_posting_hostname
    }/jobs/senior-caregiver/admin?hideHero=true&hideBody=true`;
  };
}
